const regex = /^(.+?)(?: \((\d+)\))?(\.[^.]+)?$/;

function deduplicateFileNameFactory(fileNames: string[]) {
  const s = new Set(fileNames);

  return (name: string): string => {
    let resultName = name;
    if (s.has(resultName)) {
      const result = regex.exec(resultName) || [];

      const base = result[1];
      let i = result[2] ? parseInt(result[2], 10) + 1 : 1;
      const extension = result[3] || '';

      while (s.has(resultName)) {
        resultName = `${base} (${i})${extension}`;
        i += 1;
      }
    }
    s.add(resultName);
    return resultName;
  };
}

export default deduplicateFileNameFactory;
